import isDomElement from "../../helpers/isDomElement";
import ReactDOM from "react-dom";
import Widget from "../Widget/Widget";
import PropTypes from "prop-types";
import React, {useEffect} from "react";
import InitializationErrorMessage from "../InitializationErrorMessage/InitializationErrorMessage";
import Loading from "../Loading/Loading";
import {logInfo} from "../../helpers/debugLog";


const WidgetPortal = (props) => {
    const {
        isClosed,
        targetElt,
        viewmode,
        isLoading,
        error,
        input,
        closeBtn,
        closeBtnCallback
    } = props;

    useEffect(() => {
        logInfo('closeBtn', closeBtn);
        logInfo('closeBtnCallback', typeof closeBtnCallback === 'function' ? closeBtnCallback.name : typeof closeBtnCallback );
    }, [closeBtn, closeBtnCallback]);

    if(targetElt && isDomElement(targetElt) && isLoading) {
        return ReactDOM.createPortal(
            <Loading />,
            targetElt
        );
    }

    if(targetElt && isDomElement(targetElt) && error) {
        return ReactDOM.createPortal(
            <InitializationErrorMessage error={error} />,
            targetElt
        );
    }

    if(isClosed || !targetElt || !isDomElement(targetElt) || !input || !viewmode) {
        return null;
    }

    return ReactDOM.createPortal(
        <Widget viewmode={viewmode} input={input} closeBtn={closeBtn} closeBtnCallback={closeBtnCallback} />,
        targetElt
    );

}

WidgetPortal.propTypes = {
    isClosed: PropTypes.bool.isRequired,
    isLoading: PropTypes.bool.isRequired,
    targetElt: PropTypes.object,
    viewmode: PropTypes.string,
    input: PropTypes.object,
    error: PropTypes.string
}

export default WidgetPortal;